import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Busonrentpargaondaund() {



const cardData =
  {
    keyword: 'Bus On Rent Pargaon Daund',
    heading: 'Sanavi Travels: Bus On Rent Pargaon Daund',
    headingDescription: 'Sanavi Travels offers dependable and professional Bus On Rent Pargaon Daund, delivering safe, spacious, and comfortable transportation solutions for families, local residents, corporate groups, schools, wedding guests, picnic travelers, and outstation tours. Pargaon, located near Daund in Pune district, is surrounded by agricultural villages, small industries, educational institutions, and social venues, resulting in frequent demand for organized group transportation. To cater to these needs, we provide a diverse fleet of AC buses, Non-AC buses, mini buses, luxury coaches, and high-capacity buses suitable for both short-distance and long-distance travel. Each vehicle is well-maintained with comfortable seating, proper ventilation, smooth suspension, and ample luggage space to ensure a pleasant journey. With experienced drivers familiar with Pargaon, Daund, and nearby routes, flexible rental options including one-way, round-trip, and multi-day packages, transparent pricing with no hidden charges, and 24/7 customer support, bus rental in Pargaon Daund becomes simple, safe, and hassle-free. Choose Sanavi Travels for trusted bus rental services in Pargaon Daund, ensuring punctuality, safety, comfort, and seamless group travel for every occasion.',

    top: 'Top Places to Visit Near Pargaon Daund with Sanavi Travels',


"topPlaces": [
  {
    "title": "Pargaon Village",
    "description": "Pargaon is a well-established village near Daund, known for its agricultural activities, community life, and regular social gatherings. The village frequently hosts weddings, religious functions, and local events that involve large groups of people traveling together. Bus rentals play a crucial role in managing such group movements efficiently by ensuring everyone travels together, arrives on time, and enjoys a comfortable journey. Pargaon’s road connectivity with Daund and surrounding villages makes bus hire an economical and practical solution for both local and regional travel needs."
  },
  {
    "title": "Daund Town",
    "description": "Daund is a major railway junction and commercial hub close to Pargaon, attracting daily visitors for work, trade, education, and healthcare. Residents of Pargaon frequently travel to Daund for official purposes, shopping, and social visits. Hiring a bus for group travel to Daund helps reduce congestion, coordinate timings, and ensure a smooth travel experience, especially during busy market days and festival seasons."
  },
  {
    "title": "Agricultural Villages Around Pargaon",
    "description": "The surrounding region of Pargaon consists of fertile agricultural villages cultivating sugarcane, grains, and seasonal crops. These villages are often visited for family events, rural exposure programs, and community gatherings. Bus hire services are ideal for navigating rural roads safely while providing comfort for passengers of all ages, making group travel organized and stress-free."
  },
  {
    "title": "Local Temples and Religious Sites",
    "description": "Several village temples and religious sites around Pargaon attract devotees throughout the year, particularly during festivals and religious celebrations. Group travel by bus makes temple visits convenient and organized, allowing families and devotees to travel together comfortably while maintaining safety and discipline."
  },
  {
    "title": "Weekly Markets and Bazaars",
    "description": "Weekly markets near Pargaon are important centers of trade and social interaction, drawing farmers, traders, and shoppers from nearby areas. Bus rentals are often used for group visits, trader associations, and community travel, providing a cost-effective and convenient transport option."
  },
  {
    "title": "Wedding Lawns and Event Venues",
    "description": "Wedding halls and open event venues around Pargaon and Daund rely heavily on bus rentals for guest transportation. Buses help manage large crowds efficiently by ensuring timely arrivals, minimizing parking challenges, and simplifying event logistics."
  },
  {
    "title": "Educational Institutions Nearby",
    "description": "Schools and colleges in the surrounding region organize educational tours, sports events, and cultural programs throughout the year. Bus hire services provide safe, supervised, and reliable transportation for students and staff, ensuring punctuality and smooth coordination."
  },
  {
    "title": "Picnic and Leisure Spots",
    "description": "Open countryside areas, small water bodies, and leisure spots near Pargaon are popular for school picnics, family outings, and group trips. Hiring a bus allows groups to travel together, enjoy the journey, and return safely without coordination issues."
  },
  {
    "title": "Industrial and Commercial Areas",
    "description": "Small industrial units and commercial establishments around Daund generate regular employee and visitor movement from Pargaon. Bus hire services support corporate travel, staff transport, and organized group movement for business needs."
  },
  {
    "title": "Outstation Travel Routes",
    "description": "Pargaon is well connected to Pune, Solapur, Ahmednagar, Shirdi, and other nearby destinations. Bus rentals are ideal for outstation group travel, offering comfort, safety, and cost-effective transportation for tours, pilgrimages, and family trips."
  }
]
,



"services": [
{
"name": "Bus On Rent Pargaon Daund",
"description": "Bus On Rent Pargaon Daund provides reliable and comfortable buses for families, schools, corporate groups, and social events. This service is ideal for weddings, picnics, school trips, religious journeys, and outstation travel. Our buses are spacious, clean, and well-maintained, featuring comfortable seating, proper ventilation, smooth suspension, and ample luggage space. Professional drivers ensure disciplined driving, punctual pickups, and safe journeys, making group travel smooth and stress-free."
},
{
"name": "Bus Hire in Pargaon Daund",
"description": "Bus Hire in Pargaon Daund offers flexible and convenient rental options for short-term and long-term travel needs. Whether it is a local function, community gathering, or extended tour, this service ensures organized transportation with reliable scheduling and suitable bus choices."
},
{
"name": "AC Bus Rental Pargaon",
"description": "AC Bus Rental Pargaon is ideal for travelers seeking enhanced comfort during hot weather and long journeys. Fully air-conditioned interiors, cushioned seating, and smooth ride quality make AC buses suitable for weddings, corporate travel, and long-distance tours."
},
{
"name": "Non AC Bus Hire Pargaon",
"description": "Non AC Bus Hire Pargaon provides economical transportation for short-distance travel, rural routes, school trips, and local group journeys. These buses are budget-friendly, reliable, and suitable for frequent use."
},
{
"name": "Luxury Bus on Rent Pargaon Daund",
"description": "Luxury Bus on Rent Pargaon Daund delivers premium travel experiences with modern interiors, stylish seating, and superior comfort. Ideal for weddings, VIP travel, and special occasions, these buses ensure an elegant and memorable journey."
},
{
"name": "Mini Bus Hire Pargaon",
"description": "Mini Bus Hire Pargaon is perfect for small to medium-sized groups such as family outings, office teams, and local events. Mini buses offer comfort, easy maneuverability, and economical pricing."
},
{
"name": "32 Seater Bus on Rent Pargaon",
"description": "32 Seater Bus on Rent Pargaon suits medium-sized groups including school excursions, corporate outings, and community functions, offering balanced capacity and comfort."
},
{
"name": "35 Seater Bus Hire Pargaon Daund",
"description": "35 Seater Bus Hire Pargaon Daund supports larger group travel needs such as weddings, religious tours, and long-distance journeys with organized seating and professional drivers."
},
{
"name": "Bus on Rent Pargaon for Wedding",
"description": "Bus on Rent Pargaon for Wedding ensures timely and coordinated transportation for wedding guests and family members, reducing travel stress and improving event management."
},
{
"name": "Bus Hire Pargaon for Picnic",
"description": "Bus Hire Pargaon for Picnic provides safe and enjoyable transportation for school picnics, family outings, and group leisure trips."
},
{
"name": "Bus Rental Pargaon for Corporate",
"description": "Bus Rental Pargaon for Corporate supports employee travel, meetings, conferences, and team outings with a focus on punctuality and professionalism."
},
{
"name": "Bus on Rent Pargaon Outstation",
"description": "Bus on Rent Pargaon Outstation offers dependable long-distance transportation to nearby cities and pilgrimage destinations with passenger comfort as a priority."
},
{
"name": "Bus Hire Pargaon with Driver",
"description": "Bus Hire Pargaon with Driver provides chauffeur-driven buses where experienced drivers manage routes, traffic, and safety, allowing passengers to relax."
},
{
"name": "Cheap Bus Rental Pargaon Daund",
"description": "Cheap Bus Rental Pargaon Daund delivers budget-friendly bus hire solutions without compromising on safety, cleanliness, or service reliability."
},
{
"name": "Best Bus Service Pargaon",
"description": "Best Bus Service Pargaon is known for clean buses, disciplined drivers, transparent pricing, and customer-focused service, making Sanavi Travels a trusted choice."
}
],
"tableData": [
["Bus On Rent Pargaon Daund", "Bus Hire in Pargaon Daund"],
["AC Bus Rental Pargaon", "Non AC Bus Hire Pargaon"],
["Luxury Bus Pargaon", "Mini Bus Hire Pargaon"],
["32 Seater Bus Pargaon", "35 Seater Bus Pargaon Daund"],
["Wedding Bus Pargaon", "Picnic Bus Pargaon"],
["Corporate Bus Pargaon", "Outstation Bus Pargaon"],
["Bus Hire Pargaon with Driver", "Cheap Bus Rental Pargaon Daund"],
["Best Bus Service Pargaon", "—"]
]
,


"whychoose": [
  {
    "WhyChooseheading": "Bus On Rent Pargaon Daund with Sanavi Travels",
    "WhyChoosedescription": "Sanavi Travels is a trusted provider of bus rental services in Pargaon Daund for families, schools, corporate groups, and social events."
  },
  {
    "WhyChooseheading": "Clean and Comfortable Buses",
    "WhyChoosedescription": "Our buses are regularly maintained and designed to provide a smooth and comfortable travel experience."
  },
  {
    "WhyChooseheading": "Experienced Local Drivers",
    "WhyChoosedescription": "Our drivers are familiar with Pargaon, Daund, and nearby routes, ensuring safe and timely journeys."
  },
  {
    "WhyChooseheading": "Transparent Pricing",
    "WhyChoosedescription": "We follow honest pricing policies with no hidden charges for bus rentals."
  },
  {
    "WhyChooseheading": "24/7 Customer Support",
    "WhyChoosedescription": "Our support team is available round the clock to assist with bookings and journey coordination."
  },
  {
    "WhyChooseheading": "Flexible Rental Options",
    "WhyChoosedescription": "We offer hourly, full-day, multi-day, and customized bus hire plans based on travel needs."
  },
  {
    "WhyChooseheading": "Safe and Sanitized Vehicles",
    "WhyChoosedescription": "All buses are thoroughly cleaned and sanitized before every trip for passenger safety."
  },
  {
    "WhyChooseheading": "Reliable and Punctual Service",
    "WhyChoosedescription": "We ensure on-time pickups and disciplined operations, making Sanavi Travels a dependable choice."
  }
]

}

const faqData = [
  {
    question: 'Does Sanavi Travels provide bus rental services in Pargaon Daund?',
    answer: 'Yes, Sanavi Travels offers reliable bus rental services in Pargaon Daund for all types of group travel.'
  },
  {
    question: 'What types of buses are available in Pargaon?',
    answer: 'We offer AC buses, Non-AC buses, mini buses, luxury buses, 32-seater and 35-seater buses.'
  },
  {
    question: 'Is bus rental available for weddings and picnics?',
    answer: 'Yes, we provide dedicated bus services for weddings, picnics, and social events.'
  },
  {
    question: 'Can I book a bus for outstation travel?',
    answer: 'Yes, we provide outstation bus rentals from Pargaon to multiple destinations.'
  },
  {
    question: 'Are the buses sanitized?',
    answer: 'Yes, all buses are cleaned and sanitized before each trip.'
  },
  {
    question: 'Is customer support available during travel?',
    answer: 'Yes, our 24/7 support team remains available throughout the journey.'
  }
];

const testimonials = [
  {
    id: 1,
    name: 'Mr. Dinesh Pawar',
    feedback: 'We hired a bus from Pargaon for a wedding near Daund. Very comfortable and well-managed service.',
    rating: 5
  },
  {
    id: 2,
    name: 'Ms. Sneha Deshmukh',
    feedback: 'Sanavi Travels arranged a bus for our picnic from Pargaon. Clean bus and smooth journey.',
    rating: 5
  }
];














  const Images = [
    { place: "/images/keyword/1.jpg", text: "Tempo Traveller On Rent in Pune", link: "tempo-traveller-on-rent-in-pune" },
    { place: "/images/keyword/2.jpg", text: "Pune to Shirdi Tempo Traveller On Rent", link: "pune-to-shirdi-tempo-traveller-on-rent" },
    { place: "/images/keyword/3.jpg", text: "Pune to Mahabaleshwar Tempo Traveller on Rent", link: "pune-to-mahabaleshwar-tempo-traveller-on-rent" },
    { place: "/images/keyword/4.jpg", text: "Pune to Goa Tempo Traveller Hire", link: "pune-to-goa-tempo-traveller-hire" },
    { place: "/images/keyword/5.jpg", text: "Pune to Mumbai Tempo Traveller on Rent", link: "pune-to-mumbai-tempo-traveller-on-rent" },
    { place: "/images/keyword/6.jpg", text: "Pune to Konkan Darshan Tempo Traveller Hire", link: "pune-to-konkan-darshan-tempo-traveller-hire" },
    { place: "/images/keyword/7.jpg", text: "Pune to Nashik Tempo Traveller On Rent", link: "pune-to-nashik-tempo-traveller-on-rent" },
    { place: "/images/keyword/8.jpg", text: "Tempo Traveller On Rent for Pune Darshan", link: "tempo-traveller-on-rent-for-pune-darshan" },
    { place: "/images/keyword/9.jpg", text: "Mini Bus On Rent in Pune", link: "mini-bus-on-rent-in-pune" },
    { place: "/images/keyword/10.jpg", text: "13 Seater Tempo Traveller On Rent in Pune", link: "13-seater-tempo-traveller-on-rent-in-pune" },
    { place: "/images/keyword/11.jpg", text: "17 Seater Tempo Traveller on Rent in Pune", link: "17-seater-tempo-traveller-on-rent-in-pune" },
    { place: "/images/keyword/12.jpg", text: "20 Seater Luxury Bus On Rent Pune", link: "20-seater-luxury-bus-on-rent-pune" },
    { place: "/images/keyword/13.jpg", text: "26 Seater Tempo Traveller On Rent in Pune", link: "26-seater-tempo-traveller-on-rent-in-pune" },
    { place: "/images/keyword/14.jpg", text: "32 Seater Luxury Bus On Rent in Pune", link: "32-seater-luxury-bus-on-rent-in-pune" },
    { place: "/images/keyword/15.jpg", text: "35 Seater Bus on Rent in Pune", link: "35-seater-bus-on-rent-in-pune" },
    { place: "/images/keyword/16.jpg", text: "45 Seater Bus On Rent in Pune", link: "45-seater-bus-on-rent-in-pune" },
    { place: "/images/keyword/17.jpg", text: "50 Seater Bus On Rent in Pune", link: "50-seater-bus-on-rent-in-pune" },
    { place: "/images/keyword/18.jpg", text: "Bus Hire for School Trips in Pune", link: "bus-hire-for-school-trips-in-pune" },
    { place: "/images/keyword/19.jpg", text: "Bus booking for Wedding in Pune", link: "bus-booking-for-wedding-in-pune" },
    { place: "/images/keyword/20.jpg", text: "Bus Booking for Marriage in Pune", link: "bus-booking-for-marriage-in-pune" },
    { place: "/images/keyword/21.jpg", text: "Bus Service for Corporate in Pune", link: "bus-service-for-corporate-in-pune" },
    { place: "/images/keyword/22.jpg", text: "Bus on Rent For Event in Pune", link: "bus-on-rent-for-event-in-pune" },
    { place: "/images/keyword/23.jpg", text: "Bus Hire for Outstation in Pune", link: "bus-hire-for-outstation-in-pune" },
    { place: "/images/keyword/24.jpg", text: "AC Bus On Rent in Pune", link: "ac-bus-on-rent-in-pune" },
    { place: "/images/keyword/25.jpg", text: "Pune Bus Hire Rental Service", link: "pune-bus-hire-rental-service" },
  ];








const jsonData = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Bus On Rent Pargaon Daund - Sanavi Travels",
  "description": "Sanavi Travels offers bus on rent in Pargaon Daund for weddings, corporate travel, picnics, and outstation trips. We provide AC and Non-AC buses, luxury buses, mini buses, 32 seater and 35 seater buses with professional drivers at affordable rates.",
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.7",
    "ratingCount": "190"
  }
};

<Helmet>
  <title>
    Call : +91 7387507373 | Bus On Rent Pargaon Daund | Sanavi Travels
  </title>

  <meta
    name="description"
    content="Book bus on rent in Pargaon Daund with Sanavi Travels. AC & Non-AC buses, luxury and mini bus rental for weddings, corporate travel, picnics, and outstation trips with driver at best prices."
  />

  <script type="application/ld+json">
    {JSON.stringify(jsonData)}
  </script>
</Helmet>






  return (
    <div>



      <div className="page-headder bg-section parallaxie">
        <div className="container">
          <div className="row">
            <div className="col-lg-12">
              <div className="page-header-box text-white">
                <h1 className="text-anime-style-3 text-center text-white" data-cursor="-opaque">
                  <h3> {cardData.keyword}</h3>
                </h1>
              </div>
            </div>
          </div>
        </div>
      </div>





      <section>
        <div className="container-fluid" >
          <div className="row container-fluid p-0">
            <div className="col-12 col-md-7 bg-foootr">
              <img src='/images/keyword/219.jpg' alt='img' className='img-fluid' />
              <h3 className="py-1"
                style={{
                  color: '#183765', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
              <div className="topPlaces">
                <p className="sectionLead">{cardData.top}</p>

                {cardData.topPlaces.map((place, index) => (
                  <article key={index} className="placeCard" tabIndex="0">
                    <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                    <div className="placeBody">
                      <h4 className="placeTitle">{place.title}</h4>
                      <p className="placeDesc">{place.description}</p>
                    </div>

                    <span className="placeArrow" aria-hidden>›</span>
                  </article>
                ))}
              </div>



              <div className="shambhu-services">
                {cardData.services.map((service, index) => (
                  <div key={index} className="sh-service-card">

                    <div className="sh-service-left">
                      <div className="sh-service-icon">
                        🚖
                      </div>
                    </div>

                    <div className="sh-service-content">
                      <h4 className="sh-service-title">{service.name}</h4>
                      <p className="sh-service-desc">{service.description}</p>
                    </div>

                  </div>
                ))}
              </div>


              <table className="table table-responsive Border-key my-2">
                <tbody className=' Border-key'>
                  {cardData.tableData.map((row, rowIndex) => (
                    <tr className='Border-key ' key={rowIndex}>
                      {row.map((cell, cellIndex) => (
                        <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>
              <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
              <BusRatesTable />

              <div id="why-choose-section" className="why-choose-section">


                {/* Section Title */}
                <h2 className="section-title">
                  Why Choose <span>Sanavi Travels </span>
                </h2>

                {/* Cards */}
                <div className="cards-grid">
                  {cardData.whychoose.map((item, index) => (
                    <div key={index} className="why-card">
                      <div className="icon-circle">{index + 1}</div>
                      <h4 className="card-heading">{item.WhyChooseheading}</h4>
                      <p className="card-desc">{item.WhyChoosedescription}</p>
                    </div>
                  ))}
                </div>
              </div>



              <div className="row twm-faq-section-1 m-b30">


                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                  <div className="twm-faq-info-wrap">

                    <div className="section-head left">
                      <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Sanavi Travels </h2>
                    </div>


                    <div className="twm-faq-info">
                      <div className="accordion twm-acdn" id="sf-faq-accordion">

                        <FaqSection
                          title="Frequently Asked"
                          subtitle="Help & Info"
                          items={faqData}
                        />

                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <TestimonialSectionKeyword
                testimonials={testimonials}
              />


              <ContactShowcase />
            </div>

            <div className='col-12 col-md-4' >
              <div className="routeList">
                {Images.map((e, i) => {
                  const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                  const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                  return (
                    <a
                      key={e.link || i}
                      href={href}
                      className="routeItem"
                      aria-label={e.text}
                      {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                    >
                      <div className="routeThumb">
                        <img src={e.place} alt="" loading="lazy" />
                      </div>

                      <div className="routeMeta">
                        <h6 className="routeTitle">{e.text}</h6>
                        <span className="routeUnderline" />
                      </div>

                      <span className="routeArrow" aria-hidden>›</span>
                    </a>
                  );
                })}
              </div>




              <div>
                <FleetHighway />
              </div>
              <div className="pc-contact">
                <h4 className="pc-title">Contact Information</h4>

                <div className="pc-grid">
                  {/* Phones */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-telephone-fill"></i>
                      <span>Phone Numbers</span>
                    </header>

                    <div className="pc-list">
                      <a href="tel:+917387507373" className="pc-call">+91 7387507373</a>
                      <a href="tel:+919595532929" className="pc-call">+91 9595532929</a>
                    </div>

                    <div className="pc-cta">
                      <a
                        href="https://wa.me/917387507373"
                        target="_blank" rel="noopener noreferrer"
                        className="pc-whats"
                      >
                        <i className="bi bi-whatsapp me-1"></i> WhatsApp
                      </a>
                      <a href="tel:+917387507373" className="pc-primary">
                        Call Now
                      </a>
                    </div>
                  </section>

                  {/* Email */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-envelope-fill"></i>
                      <span>Email</span>
                    </header>

                    <a href="mailto:booking@sanavitravels.com" className="pc-email">
                      booking@sanavitravels.com
                    </a>
                  </section>

                  {/* Address */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-house-fill"></i>
                      <span>Address</span>
                    </header>

                    <address className="pc-address">
                      <strong>Sanavi Travels</strong><br />
                      OFFICE NO.6, GROUND FLOOR GAT NO.1110,
                      SHREE GOPINATH MAHARAJ VYAPARI SHED SHIVAJI CHOWK, VARVAND TAL DAUND,
                      DIST PUNE – 412215
                    </address>
                  </section>
                </div>
              </div>


            </div>
          </div>
        </div>
      </section>


    </div>
  );
}

export default Busonrentpargaondaund;